// extracted by mini-css-extract-plugin
module.exports = {"main-component":"startSim_main-component__38Q6V"};